var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgEyeBlack = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#444a58;}.b{fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.5,8A2.5,2.5,0,1,1,8,5.5,2.5,2.5,0,0,1,10.5,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,8S3,2.5,8,2.5,16,8,16,8s-3,5.5-8,5.5S0,8,0,8Zm8,3.5A3.5,3.5,0,1,0,4.5,8,3.5,3.5,0,0,0,8,11.5Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEyeBlack);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxMSIgdmlld0JveD0iMCAwIDE2IDExIj48ZGVmcz48c3R5bGU+LmEsLmJ7ZmlsbDojNDQ0YTU4O30uYntmaWxsLXJ1bGU6ZXZlbm9kZDt9PC9zdHlsZT48L2RlZnM+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAtMi41KSI+PHBhdGggY2xhc3M9ImEiIGQ9Ik0xMC41LDhBMi41LDIuNSwwLDEsMSw4LDUuNSwyLjUsMi41LDAsMCwxLDEwLjUsOFoiLz48cGF0aCBjbGFzcz0iYiIgZD0iTTAsOFMzLDIuNSw4LDIuNSwxNiw4LDE2LDhzLTMsNS41LTgsNS41UzAsOCwwLDhabTgsMy41QTMuNSwzLjUsMCwxLDAsNC41LDgsMy41LDMuNSwwLDAsMCw4LDExLjVaIi8+PC9nPjwvc3ZnPg==";